import HeroSection from './components/hero-section';
import FeatureSection from './components/feature-section';
import { SEO } from '@/components/common/seo';

export default function Careers() {
    return (
        <div>
            <SEO canonical="/careers" />
            <HeroSection />
            <FeatureSection />
        </div>
    )
}
